import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3a5ba274: FaireBrandEntity = {
  token: "b_3a5ba274",
  type: "brand",
  name: "Lucky Horse Press",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/31375e7d9500ae5e209f16d2447fcb70dca3df41ea0568dc316893bac0d17aab/1527816305.jpg",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/527ac4de833a2da7f681bf1089fd2294f91ce450aa76d0563e752f67246ca065/1498007064.png",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/31375e7d9500ae5e209f16d2447fcb70dca3df41ea0568dc316893bac0d17aab/1527816305.jpg",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/527ac4de833a2da7f681bf1089fd2294f91ce450aa76d0563e752f67246ca065/1498007064.png",
  location: "Basking Ridge, NJ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 152,
  isInsider: true,
  description:
    "Michele Lee is a designer and printer and much of her creative inspiration comes from music, memories and irreverent things. After having learned letterpress in New York City and screen printing from old art class instructions, a great fondness for printing and color experimentation developed and Lucky Horse Press was born with the mission to create general happiness for all. Michele makes all of the printed goods available in the shop from her studio in the Garden State, where some of the best things in life are easily accessible - beaches, yard sales and bowling alleys.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:57.097Z",
    importedBy: "entity-db-cli",
  },
};
